var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-date-picker',{attrs:{"value":_vm.pickedDate,"prefix-class":"wiq","valueType":"format","formatter":_vm.momentFormat,"type":"date","placeholder":_vm.placeholder,"disabled-date":_vm.disabledDate},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }